<template>
  <b-row class="dyslipidemia disease-pages no-gutters">
     <b-col class="tool-border" cols="12">
    <b-col class="reduce-padding" cols="12">
      <wlpHeader :pageTitle="pageTitle" :pageImage="pageImage"></wlpHeader>
    </b-col>
   
      <b-col class="page-background-gradient reduce-padding" cols="12">
      <b-row class="page-content  no-gutters">
        <b-row class="body-sec no-gutters">
          <b-col class="reduce-padding top-section" cols="12">
            <b-row class="no-gutters">
              <b-col class="reduce-padding text-section" lg="8" md="8" cols="12">
                <div class="top-text-title bold-text"  v-if="!userData.conditions.hyplip">
                  {{$t('common.top-text-title')}}
                </div>
                <div class="top-text" :class="{'top-text-sp' : $i18n.locale=='sp'}"   v-if="!userData.conditions.hyplip">
                  {{$t('dyslipidemia.top-text')}}  </div>
                
                 <div class="top-text-title bold-text"  v-if="userData.conditions.hyplip">
                  {{$t('common.top-text-title3')}}
                </div>
                <div class="top-text toptxt-dyslip" :class="{'top-text-sp' : $i18n.locale=='sp','toptxt-dyslip-sp' : $i18n.locale=='sp'}"  v-if="userData.conditions.hyplip">
               {{$t('dyslipidemia.top-text2')}} 
               </div>
              </b-col>
              <b-col class="reduce-padding check-section" lg="4" md="4" sm="12"  cols="12">
                <b-row class="check-yes-section dyslip-check no-gutters">
                    <div class="condition-checkboxes wlp-checkboxes">
                  <input @change="toggleAdjButtons()" type="checkbox" name="hlpCondition" v-model="userData.conditions.hyplip" id="hlpCondition" value="hlpCondition">
                  <label class="" for="hlpCondition">
                      <div class="condition-label">{{$t('dyslipidemia.condition-label-1')}}<br>{{$t('dyslipidemia.condition-label-2')}}<br>{{$t('dyslipidemia.condition-label-3')}}</div>
                  </label>
                </div>
                </b-row>
                
              </b-col>
            </b-row>
            <div class="top-hr-hyperlipidemia" :class="{'hr-margin' : userData.conditions.hyplip }"></div>
          </b-col>
          
          <b-col class="reduce-padding graph-col" lg="8" md="7" cols="12">
            <div class="ldl-trigs-btn-section" v-if="!userData.conditions.hyplip">
              <b-col class="reduce-padding"  cols="12">
                <div class="graph-title graph-title-space graph-title-common bold-text">
                  {{$t('graph.lineGraphTitle')}} {{$t('common.dyslipidemia2')}}
                </div>
                <div class="graph-sub-title graph-title-common">
                  <span v-if="userData.adjustButtons.hyplip>0">{{userData.adjustButtons.hyplip}}% {{$t('graph.lineGraphSubTitle')}} </span>(%)
                </div>
              </b-col>
            </div>
            <div class= "input-fields" v-if="userData.conditions.hyplip" >  
              <b-col class="reduce-padding">
                <b-row class="no-gutters">
                  <div class="title-cholesterol-levels"> {{$t('dyslipidemia.current-levels')}}</div>
                </b-row>
                <b-row class= "no-gutters" >
                    <b-col class = "reduce-padding" cols="12">
                      <b-row class="no-gutters">
                        <b-col class="reduce-padding" lg = "7" md="12" cols="12">
                          <div class ="trigs-field" :class="{'haserror': submitted &&  ( (!$v.userData.trigs.required || !$v.userData.trigs.numeric || 
                    !$v.userData.trigs.minLength || !$v.userData.trigs.maxLength || 
                    !$v.userData.trigs.between) ) }">
                            <div class = "field-txt">
                              <div class = "txt-heading">{{$t('dyslipidemia.trig')}}  <span class = "txt-normal">(90+):</span></div>
                             
                            </div>
                            <div class="cholesterol-levels">
                              <input @change="updatebars()" class="common-fields trigs" name="trigs" type="text"  v-model.number="userData.trigs" maxLength="3" placeholder="---" :class="{'greytxt': this.$v.userData.trigs.$invalid }">
                            </div>
                          </div>
                        </b-col>
                        <b-col class="reduce-padding" lg = "5" md="12" cols="12">
                          <div class ="hdl-field hdl-field-ff2 hdl-field-ff" :class="{'haserror': submitted &&  ( (!$v.userData.hdl.required || !$v.userData.hdl.numeric || 
                    !$v.userData.hdl.minLength || !$v.userData.hdl.maxLength || 
                    !$v.userData.hdl.between) ) }">
                            <div class = "field-txt">
                              <div class = "txt-heading">HDL  <span class = "txt-normal">(20-100):</span></div>
                             
                            </div>
                            <div class="cholesterol-levels">
                              <input @change="updatebars()" class="common-fields hdl" name="trigs" type="text" v-model.number="userData.hdl" maxLength="3" placeholder="---" :class="{'greytxt': this.$v.userData.hdl.$invalid }">
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                  
                </b-row>
                <b-row class="hyperlipidemia-graph-title bold-text no-gutters" :class="{'hyperlipidemia-graph-title-sp': $i18n.locale=='sp'}">
                  <div class="validation-div" :class="{'validation-div-sp': $i18n.locale=='sp'}">
                       <div class="validation-txt" v-if="( submitted &&  (!$v.userData.trigs.required || !$v.userData.trigs.numeric || 
                      !$v.userData.trigs.minLength || !$v.userData.trigs.maxLength || !$v.userData.trigs.between ) ) || ( submitted &&  (!$v.userData.hdl.required || !$v.userData.hdl.numeric || 
                      !$v.userData.hdl.minLength || !$v.userData.hdl.maxLength || !$v.userData.hdl.between ) )">{{$t('error.error-required3')}}</div>
                  </div>
               
                  <div :class="{'current-vs-adjusted-sp' : $i18n.locale=='sp', 'current-vs-adjusted' : $i18n.locale=='en'}" >{{$t('dyslipidemia.bargraph-heading')}}</div>
                  <div class="graph-sub-text">
                  (mg/dL)
                  </div>
                </b-row>
                
              </b-col>
            </div>
            
            <div class="graphs-div">
              <div class="bar-graph-div" v-if="userData.conditions.hyplip">
                <barGraph :disease="'hyplip'" :barValues="userData.calc.hyplip" :adjustSelection="userData.adjustButtons.hyplip" 
                :displayBars="userData.trigs>=90 && userData.hdl>=20 && userData.hdl<=100" 
                :lblY=lblY :lblEndX="300" :lblStartX="0" :lblSkipX="20"></barGraph>
              </div>
              <div class="line-graph-div" v-if="!userData.conditions.hyplip">   
                <lineChart :disease="'dyslip'" :risk="userData.calc.dyslip" :adjustSelection="userData.adjustButtons.hyplip" :lblEndX="40" :lblSkipX="1" 
                :lblStartY="-5" :lblEndY="25" :lblSkipY="5" :confInt="this.userData.confInt.dyslip"></lineChart>
              </div>
            </div>
        
            <b-col class="graph-bottom" v-if="!userData.conditions.hyplip" cols="12">
              <!--<b-row class="no-gutters" >-->
              <!--  <b-col class="reduce-padding order-lg-1 order-2" lg="5" cols="12">-->
              <!--    <div class="bottom-section">-->
              <!--        <div class ="weight-loss-txt before-loss">-->
              <!--          <div class="bullet blue"></div>-->
              <!--          <div class="bullet-text">Before Weight Loss</div>-->
              <!--        </div>-->
              <!--        <div class ="weight-loss-txt weight-loss-txt2 after-loss">-->
              <!--          <div class="bullet green" v-if="userData.adjustButtons.hyplip>0"></div>-->
              <!--          <div class="bullet-text" v-if="userData.adjustButtons.hyplip>0">After Weight Loss</div>-->
              <!--        </div>  -->
              <!--    </div>-->
              <!--  </b-col>-->
              <!--  <b-col class="reduce-padding x-label-title order-lg-2 order-1" lg="2" cols="12">-->
              <!--    <div class="hyp-bmi-t ">BMI</div>-->
              <!--  </b-col>-->
              <!--</b-row>-->
              <b-row class="no-gutters">
                <b-col class="reduce-padding legends order-lg-1 order-2" lg="4" cols="12">
                  <b-row class=" no-gutters">
                        <b-col class="reduce-padding risk-bullets" md="4" lg="6" cols="12">
                          <div class="bullet blue"></div>
                          <div class="bullet-text" :class="{'bullet-text-sp' : $i18n.locale=='sp'}">{{$t('common.currentRisk')}}</div>
                        </b-col>
                        <b-col class="reduce-padding risk-bullets" md ="8" lg="6" cols="12">
                          <div class="bullet green" v-if="userData.adjustButtons.hyplip>0" md="6" ></div>
                          <div class="bullet-text" :class="{'bullet-text-sp' : $i18n.locale=='sp'}" v-if="userData.adjustButtons.hyplip>0"  md="6" > {{$t('common.adjustedRisk')}}</div>
                        </b-col>
                      </b-row>
                </b-col>
                <b-col class="reduce-padding x-label-title order-lg-2 order-1" lg="2" cols="12">
                  <div class="">{{$t('common.bmi')}}</div>
                </b-col>
              </b-row>
            </b-col>
            <b-col class=" graph-bottom bar-graph-bottom" v-if="userData.conditions.hyplip">
              <b-row class="no-gutters">
                <b-col class="reduce-padding" cols="12">
                  <div class="bottom-section" :class="{'bottom-section-sp' : $i18n.locale=='sp'}" v-show="userData.trigs>=90 && userData.hdl>=20 && userData.hdl<=100">
                      <div class ="weight-loss-txt before-loss">
                        <div class="bullet blue"></div>
                        <div class="bullet-text" :class="{'bullet-text-sp' : $i18n.locale=='sp'}">{{$t('common.beforeWeight')}}</div>
                      </div>
                      <div class ="weight-loss-txt after-loss">
                        <div class="bullet green" v-if="userData.adjustButtons.hyplip>0"></div>
                        <div class="bullet-text" :class="{'bullet-text-sp' : $i18n.locale=='sp'}" v-if="userData.adjustButtons.hyplip>0">{{$t('common.afterWeight')}}</div>
                      </div>  
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-col>
          
          <b-col class="reduce-padding adj-weight-col" md="4" cols="12">
            <b-row class="no-gutters top-extra-space"  :class="{'top-extra-space2':  userData.conditions.hyplip}">
              <b-col class="triangle-outer reduce-padding" cols="12">
                <div class = "triangle-img" :class="{'triangle-img1':  !userData.conditions.hyplip}"></div>
              </b-col>
              <b-col class="hyerlipidemia-adj-box reduce-padding" :class="{'hyerlipidemia-adj-box2':  userData.conditions.hyplip && $i18n.locale=='en' , 'hyerlipidemia-adj-box2-sp':  userData.conditions.hyplip && $i18n.locale=='sp' }">
                <weightAdjustmentBox :disease="diseaseName" :adjustSelection="userData.adjustButtons.hyplip" :condition="userData.conditions.hyplip" 
                @adjustPercUpdate="userData.adjustButtons.hyplip=$event" :btnClickHandler="btnClickHandler"></weightAdjustmentBox>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-row>
      
      <wlpNavigation :navButtons="['info','references','tnc','menu','back','next']" :currentScreen="4" :btnClickHandler="this.handleSubmit"></wlpNavigation>
    </b-col>
  </b-col>
  </b-row>
</template>
<script>
/* eslint-disable */
import scrollMixin from "../mixins/scrollMixin";
import wlpNavigation from '../components/wlpNavigation.vue';
import wlpHeader from '../components/wlpHeader.vue';
import lineChart from '../components/lineChart.vue';
import barGraph from '../components/barGraph.vue';
import weightAdjustmentBox from '../components/weightAdjustmentBox.vue';
import { mapGetters, mapMutations } from 'vuex';
import { required, maxLength, numeric, minLength, between } from "vuelidate/lib/validators";

export default {
  name: "dyslipidemia",
  mixins: [scrollMixin],
  components: {
     'wlpHeader': wlpHeader,
    'wlpNavigation': wlpNavigation,
    'lineChart': lineChart,
    'weightAdjustmentBox': weightAdjustmentBox, 
    'barGraph': barGraph,
  },

  data() {
    return {
      pageTitle: this.$t('common.dyslipidemia'),
      diseaseName: this.$t('common.dyslipidemia').toLowerCase(),
      pageImage: 'hyperlipidemia-img',
      submitted: false,
      isGreyTxt : false,
      isGreyTxttrigs : false,
      lblY: [this.$t('dyslipidemia.ylabel1'),this.$t('dyslipidemia.ylabel2')],
      
      isGreyTxthdl : false,
      weightLossKG: [],
    };
  },
  
     validations: {
      userData: {
        trigs: {
          required,
          numeric,
          minLength: minLength(2),
          maxLength: maxLength(3),
          between: between(90, 999)
        },

        hdl: {
          required,
          numeric,
          minLength: minLength(2),
          maxLength: maxLength(3),
          between: between(20, 100)
        },
     
      }

    },

  
  methods: {
     ...mapMutations('userData', ['saveCalculations', 'markSectionComplete']),
    toggleAdjButtons: function() {
        this.userData.adjustButtons.hyplip = this.userData.conditions.hyplip? 0: this.userData.adjustButtons.hyplip;
      },
     handleSubmit() {
        this.submitted = true;
        this.$v.$touch();
        console.log("this.$v.$invalid ", this.$v.$invalid)
        console.log("this.$v ", this.$v)
        if (this.userData.conditions.hyplip && this.$v.$invalid) {
          this.scrollToError();
          return false;
        }
         
        return true;
      },
      btnClickHandler: function() {
        if (this.userData.conditions.hyplip && this.$v.$invalid) {
          console.log("this.$v ", this.$v)
          this.submitted = true;
          this.scrollToError();
        }
      },
      getKgsLoss: function() {
        var weight = (this.userData.unitsSystem === 'englishSystem')? Math.round (this.userData.weight /2.2) : this.userData.weight;
        var weight5 = (this.userData.unitsSystem === 'englishSystem')? Math.round (this.userData.calc.weight.adj5 /2.2) : this.userData.calc.weight.adj5;
        var weight10 = (this.userData.unitsSystem === 'englishSystem')? Math.round (this.userData.calc.weight.adj10 /2.2) : this.userData.calc.weight.adj10;
        var weight15 = (this.userData.unitsSystem === 'englishSystem')? Math.round (this.userData.calc.weight.adj15 /2.2) : this.userData.calc.weight.adj15;
        var weight20 = (this.userData.unitsSystem === 'englishSystem')? Math.round (this.userData.calc.weight.adj20 /2.2) : this.userData.calc.weight.adj20;
        var loss= [weight-weight5, weight-weight10, weight-weight15, weight-weight20];
        console.log('loss : ',weight,' - ',weight5,' - ',weight10,' - ',weight15,' - ',weight20,' - ',loss);
         return loss;
      },
      
      hlpBars: function (kgsLoss) {
                  // TRIGS, HDL
       var change= [ Math.round (kgsLoss*-1.33*10)/10, Math.round (kgsLoss*0.34803*10)/10];
       
       console.log('change : ',change);
       return [Math.round(this.userData.trigs+change[0]), Math.round(this.userData.hdl+change[1])];
      },
      
      updatebars: function () {
        if(this.userData.trigs>=90 && this.userData.hdl>=20 && this.userData.hdl<=100) {
          this.hlp = {
            current: [this.userData.trigs, this.userData.hdl],
            adj5: this.hlpBars(this.weightLossKG[0]),
            adj10: this.hlpBars(this.weightLossKG[1]),
            adj15: this.hlpBars(this.weightLossKG[2]),
            adj20: this.hlpBars(this.weightLossKG[3]),
          };
          this.saveCalculations({data: this.hlp, section: 'hyplip'});
          // console.log("dys:"+this.hlp);
        }
      },
     
  },
  computed: {
    ...mapGetters('userData', ['userData']),
  },
  
  mounted: function () {
    this.scrollToTop();
    this.weightLossKG = this.getKgsLoss();
    this.updatebars();
    this.markSectionComplete({section:'hyplip'});
  },
  
};
</script>


<style lang="scss" scoped>
</style>
